
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'shopping_cart': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M6 16a2 2 0 0 0-1.99 2A2 2 0 0 0 6 20a2.006 2.006 0 0 0 2-2 2.006 2.006 0 0 0-2-2zM0 0v2h2l3.6 7.59-1.35 2.45A1.933 1.933 0 0 0 4 13a2.006 2.006 0 0 0 2 2h12v-2H6.42a.248.248 0 0 1-.25-.25l.03-.12.9-1.63h7.45a1.991 1.991 0 0 0 1.75-1.03l3.58-6.49A.977.977 0 0 0 20 3a1 1 0 0 0-1-1H4.21l-.94-2zm16 16a2 2 0 0 0-1.99 2A2 2 0 0 0 16 20a2.006 2.006 0 0 0 2-2 2.006 2.006 0 0 0-2-2z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
